module.exports = __webpack_public_path__ + "static/media/learning-content-separator.a6336f1d.png";